export default "__VITE_ASSET__GZGbGRf3__"